export function resolvePath(url, path) {
    if (path)
        return url.replace(/\{(.*?)\}/g, (a, b) => (path[b] || a) + "");
    return url;
}
export function isObject(data) {
    return Object.prototype.toString.call(data) === "[object Object]";
}
